/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-04-12 02:45:51
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-04-15 21:46:29
 * @FilePath: \zeelool-nextjs\src\components\Product\member.tsx
 * @Description: 会员标签通用组件（基于商品信息）
 */
import MemberTag from './MemberTag';
import { Product } from './ProductCard';

const Member = ({
  level,
  className = '',
  productData,
}: {
  level: number;
  className?: string;
  productData: Product;
}) => {
  if (!productData || productData[`discount_percent_v${level}`] <= 0) {
    return <></>;
  }
  return <MemberTag level={level} className={className} />;
};

export default Member;
